import React from 'react';
import { HeroImg } from 'assets/styledComponents/styledModuleComponents';

export default function HeroImage({ image, first, desktop }) {
  return (
    <HeroImg src={image.url} first={first} desktop={desktop} alt="heroimage" />
  );
}
